import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const guardian_relationships:SchemaTableOptions = {
    name:<string> 'guardian_relationships',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}